module.exports = __webpack_public_path__ + "static/img/56970_0_dziecko z psem gory_original_tr.634eb86a.png";